import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress } from '@mui/material';
import { replaceStylesheetGlobals } from '../../portal/theme/portalTheme';
import { useTokens } from '../../tokens/TokensProvider';
const AddToCartButton = ({ onAddToCart, onCheckout, disabled = false, loading = false, soldOut = false, isAddedToCart = false, buttonText, addedToCartText, checkoutText, soldOutText, loadingText, sx = {}, buttonStyle, stylesheet, }) => {
    const tokens = useTokens();
    const resolvedButtonText = buttonText || tokens.getValue('addToBagLabel');
    const resolvedAddedToCartText = addedToCartText || tokens.getValue('addedToCartLabel');
    const resolvedCheckoutText = checkoutText || tokens.getValue('checkoutLabel');
    const resolvedSoldOutText = soldOutText || tokens.getValue('soldOutLabel');
    const resolvedLoadingText = loadingText || tokens.getValue('addingLabel');
    // Determine button text based on state
    const getButtonText = () => {
        if (loading)
            return resolvedLoadingText;
        if (isAddedToCart && onCheckout)
            return resolvedCheckoutText;
        if (isAddedToCart)
            return resolvedAddedToCartText;
        if (soldOut)
            return resolvedSoldOutText;
        if (resolvedButtonText)
            return resolvedButtonText;
        return '';
    };
    // Determine button click handler
    const getClickHandler = () => {
        if (isAddedToCart && onCheckout)
            return onCheckout;
        return onAddToCart;
    };
    // Unified button styling with admin config
    const buttonStyling = {
        backgroundColor: buttonStyle?.backgroundColor
            ? replaceStylesheetGlobals(stylesheet, buttonStyle.backgroundColor)
                || buttonStyle.backgroundColor
            : undefined,
        color: buttonStyle?.color
            ? replaceStylesheetGlobals(stylesheet, buttonStyle.color)
                || buttonStyle.color
            : undefined,
        borderRadius: buttonStyle?.borderRadius || 4,
        '&:hover': {
            backgroundColor: buttonStyle?.hoverBackgroundColor
                ? replaceStylesheetGlobals(stylesheet, buttonStyle.hoverBackgroundColor)
                    || buttonStyle.hoverBackgroundColor
                : undefined,
        },
        '&:disabled': {
            backgroundColor: buttonStyle?.disabledBackgroundColor
                ? replaceStylesheetGlobals(stylesheet, buttonStyle.disabledBackgroundColor)
                    || buttonStyle.disabledBackgroundColor
                : undefined,
            color: buttonStyle?.disabledColor
                ? replaceStylesheetGlobals(stylesheet, buttonStyle.disabledColor)
                    || buttonStyle.disabledColor
                : undefined,
        },
        ...sx,
    };
    return (_jsx(Button, { variant: "contained", onClick: getClickHandler(), disabled: disabled || loading || soldOut, sx: {
            width: '100%',
            ...buttonStyling,
            ...sx,
        }, children: loading ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { size: 16, sx: { marginRight: 1 } }), resolvedLoadingText] })) : (getButtonText()) }));
};
AddToCartButton.defaultProps = {
    onCheckout: undefined,
    disabled: false,
    loading: false,
    soldOut: false,
    isAddedToCart: false,
    buttonText: '',
    addedToCartText: '',
    checkoutText: '',
    soldOutText: '',
    loadingText: '',
    sx: {},
    buttonStyle: undefined,
    stylesheet: undefined,
};
export default AddToCartButton;
//# sourceMappingURL=AddToCartButton.js.map